module.exports = __webpack_public_path__ + "static/media/ИНФОРМАЦИОННОЕ ПИСЬМО №1.94f6004b.pdf";